import { fetchHoj } from './client';
import type { Category, CategoryList } from './types';

const CACHE_KEY = 'wp:categoriesCache';

export async function listCategories(signal?: AbortSignal): Promise<Category[]> {
  try {
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (cached) {
      return JSON.parse(cached) as Category[];
    }
  } catch {
    // sessionStorage might be unavailable
  }

  const out: Category[] = [];
  let cursor: string | undefined;
  do {
    const page = await fetchHoj<CategoryList>('/v1/categories', {
      query: { limit: 100, cursor },
      signal,
    });
    out.push(...page.data);
    cursor = page.meta?.nextCursor ?? undefined;
  } while (cursor);

  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(out));
  } catch {
    // ignore
  }
  return out;
}
